import { observer } from 'mobx-react';
import { Grid, Typography } from '@material-ui/core';
import {
  createNumberFormatField, SelectField, createTextField,
} from '@roc/ui';
import { bankInformationPropertyStates, isNotBlank } from '@roc/feature-utils';
import { Tooltip } from '@roc/ui';
import HelpIcon from '@material-ui/icons/Help';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { useExternalAgentLoansStore } from 'libs/feature-title-agent/src/hooks/useExternalAgentLoansStore';
import { useEffect } from 'react';
const useStyles = makeStyles((theme: Theme) => {
  return {
    list: {
      padding: '0px',
    },
    netWorth: {
      color: '#48AD25',
      lineHeight: '56px',
    },
    icon: {
      fontSize: '18px',
      marginLeft: '5px',
      marginBottom: '2px',
    },
  };
});

export const VendorBankInformationDetailsForm = observer(() => {
  const { vendorCompanyProfileStore } = useExternalAgentLoansStore();
  const { vendorBankInformationStore, companyInformation } = vendorCompanyProfileStore;
  const { bankInformationFormStore } = vendorBankInformationStore
  const classes = useStyles();


  useEffect(() => {
    vendorBankInformationStore.fillContactInformation();
  }, []);


  return (
    <>
      <Grid container xs={12} sm={12} direction='row'>
        <Typography variant="h5">
          Account Details
          <Tooltip title="Please verify the account details to ensure accuracy before submitting">
            <HelpIcon className={classes.icon} fontSize="small" />
          </Tooltip>
        </Typography>
      </Grid>
      <Grid item xs={12} sm={6}>
        {createTextField({
          label: 'Account Name/Title',
          fieldName: 'beneficiaryAccountName',
          testId: 'accountName',
          store: bankInformationFormStore,
        })}
      </Grid>
      <Grid item xs={12} sm={6}>
        {createNumberFormatField({
          label: 'ABA (FedWire) Routing Number:',
          fieldName: 'beneficiaryRoutingNumber',
          format: "#########",
          testId: 'routingNumber',
          store: bankInformationFormStore,
        })}
      </Grid>
      <Grid item xs={12} sm={6}>
        {createNumberFormatField({
          label: 'Account Number:',
          fieldName: 'beneficiaryAccountNumber',
          testId: 'accountNumber',
          store: bankInformationFormStore,
        })}
      </Grid>
      <Grid item xs={12} sm={6}>
        {createTextField({
          label: 'Bank Name',
          fieldName: 'beneficiaryBankName',
          testId: 'bankName',
          store: bankInformationFormStore,
        })}
      </Grid>
      <Grid item xs={12}>
        <Typography variant="h5">Contact Information</Typography>
      </Grid>
      <Grid item xs={12} sm={6}>
        {createTextField({
          label: 'Street Name',
          fieldName: 'streetName',
          testId: 'streetName',
          store: bankInformationFormStore,
        })}
      </Grid>
      <Grid item xs={12} sm={6}>
        {createTextField({
          label: 'City',
          fieldName: 'city',
          testId: 'city',
          store: bankInformationFormStore,
        })}
      </Grid>
      <Grid item xs={12} sm={6}>
        {createTextField({
          label: 'Zip Code',
          fieldName: 'zipCode',
          testId: 'zipCode',
          store: bankInformationFormStore,
        })}
      </Grid>
      <Grid item xs={12} sm={6}>
        <SelectField
          standaloneLabel
          label={'State'}
          name={'state'}
          value={bankInformationFormStore.form.fields.state.value}
          error={isNotBlank(
            bankInformationFormStore.form.fields.state.error
          )}
          errorText={
            bankInformationFormStore.form.fields.state.error
          }
          options={bankInformationPropertyStates}
          onChange={label =>
            bankInformationFormStore.onFieldChange('state', label)
          }
          variant="outlined"
          fullWidth
          shrink
          required
          testId="state"
        />
      </Grid>
    </>
  )
});